function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { memo } from "react";
import styled from "styled-components";
import { color } from "../../../helpers/color";
import { useDuration } from "./state/duration";
const Root = /*#__PURE__*/styled.div.withConfig({
  displayName: "Root",
  componentId: "sc-dwfxgf-0"
})(["position:absolute;overflow:hidden;width:100%;height:100%;border-right:2px solid ", ";"], color);
Root.defaultProps = {
  color: "default"
};

// const Text = styled.div`
// 	${secondaryBackground};

// 	position: absolute;
// 	top: 50%;
// 	right: 0;
// 	color: ${defaultColor};
// 	font-size: 10px;
// 	text-transform: uppercase;
// 	transform: translate(-8px, -50%);
// 	opacity: 0;

// 	${Root}:hover & {
// 		opacity: 1;
// 	}
// `;

const Progress = /*#__PURE__*/memo(({
  value,
  children,
  ...props
}) => {
  const duration = useDuration();
  return /*#__PURE__*/React.createElement(Root, _extends({
    style: {
      right: `${(1 - value / duration) * 100}%`
    }
  }, props));
});
export default Progress;
//# sourceMappingURL=Progress.js.map